// tienda/ProcesoSection.jsx
// Three-stage operating flow from order intake to auditable closure.

import React from "react";
import { motion } from "framer-motion";
import { BadgeCheck, Boxes, Cable } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const STEPS = [
  {
    title: "Conecta tus pedidos",
    icon: Cable,
    text: "Registra pedidos desde la plataforma, carga masiva o integraciones disponibles, con la información que la operación necesita.",
    meta: "Entrada estructurada",
  },
  {
    title: "Fast Max los orquesta",
    icon: Boxes,
    text: "Coordinamos recojo o fulfillment, ruta, comunicación y seguimiento según el servicio elegido y la cobertura disponible.",
    meta: "Ejecución conectada",
  },
  {
    title: "Cierra con visibilidad",
    icon: BadgeCheck,
    text: "La entrega, incidencias y contraentrega quedan disponibles para seguimiento, conciliación y decisiones posteriores.",
    meta: "Verdad operativa",
  },
];

export function ProcesoSection() {
  return (
    <section id="proceso" className="border-b bg-white scroll-mt-16" style={{ borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <motion.div {...fadeUp} className="mx-auto mb-10 max-w-3xl text-center">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
            Cómo funciona
          </p>
          <h2 className="text-3xl font-black md:text-4xl" style={{ color: brand.ink }}>
            Un flujo conectado de pedido a entrega.
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed md:text-base" style={{ color: brand.muted }}>
            Menos pasos aislados, menos información perdida y más contexto para operar cada pedido.
          </p>
        </motion.div>

        <div className="relative grid gap-4 lg:grid-cols-3">
          <div className="absolute left-[16%] right-[16%] top-10 hidden h-px lg:block" style={{ background: brand.line }} />
          {STEPS.map(({ title, icon: Icon, text, meta }, index) => (
            <motion.article
              key={title}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: index * 0.07 }}
              className="relative rounded-2xl border bg-white p-6 shadow-sm"
              style={{ borderColor: brand.line }}
            >
              <div className="mb-6 flex items-center justify-between">
                <span
                  className="grid size-12 place-items-center rounded-2xl text-white shadow-lg"
                  style={{ background: index === 1 ? brand.plum : brand.primary }}
                >
                  <Icon className="size-5" />
                </span>
                <span className="text-5xl font-black" style={{ color: `${brand.primary}12` }}>0{index + 1}</span>
              </div>
              <p className="text-[10px] font-black uppercase tracking-[0.16em]" style={{ color: brand.primary }}>{meta}</p>
              <h3 className="mt-2 text-lg font-black" style={{ color: brand.ink }}>{title}</h3>
              <p className="mt-3 text-sm leading-relaxed" style={{ color: brand.muted }}>{text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
